import React, { useEffect, useState } from "react";

import { push } from "connected-react-router";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { reducerType } from "redux/reducers";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import HeaderBarSub from "components/HeaderBarSub";
import { useTranslation } from "react-i18next";
import GridFullHeight from "components/GridFullHeight";
import GridFormContainer from "components/GridFormContainer";
import clsx from "clsx";
import styles from "./styles";
import Container from "@material-ui/core/Container";
// Page components
import ActivityTab from "./components/ActivityTab";
import BadgesTab from "./components/BadgesTab";
import StatisticsTab from "./components/StatisticsTab";
import CertificatesTab from "./components/CertificatesTab";

interface MyWorkProps {
  dispatch: Dispatch;
  router: {
    pathname: string;
    search: string;
    hash: string;
  };
}

const mapStateToProps = (state: reducerType) => {
  return {
    loading: state.service.loading,
    router: state.router.location,
  };
};

const BADGES_TAB_INDEX = 2;

const MyWork = React.memo((props: MyWorkProps) => {
  const { dispatch, router } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const classes = styles();
  const translate = useTranslation().t;

  const tabs = [ "STATISTICS", "ACTIVITY", "BADGES", "CERTIFICATES"];

  useEffect(() => {
    const tab = new URLSearchParams(router.search).get("tab");
    if (tab === "badges") {
      setSelectedIndex(BADGES_TAB_INDEX);
    }
  }, [router.search]);

  const openUrl = (url) => {
    dispatch(push(url));
  };

  return (
    <GridFullHeight container>
      <GridFormContainer item xs={12} sm={12} md={12}>
        <GridFullHeight container>
          <HeaderBarSub
            openUrl={openUrl}
            isSearch={false}
            name={translate("MY_WORK")}
          />
          {/* Toolbar */}
          <Container className={classes.root}>
            <ButtonGroup
              className={classes.groupBtns}
              variant="contained"
              color="primary"
              aria-label="contained primary button group"
            >
              {tabs.map((tab, idx) => (
                <Button
                  key={idx}
                  onClick={() => setSelectedIndex(idx)}
                  className={clsx(
                    {
                      [classes.btnActive]: idx === selectedIndex,
                    },
                    classes.btnFilter
                  )}
                >
                  {translate(tab)}
                </Button>
              ))}
            </ButtonGroup>
          </Container>

          {/* Content */}
          <Container className={classes.root}>
            {selectedIndex === 0 && <StatisticsTab />}
            {selectedIndex === 1 && <ActivityTab />}
            {selectedIndex === 2 && <BadgesTab />}
            {selectedIndex === 3 && <CertificatesTab />}
          </Container>
        </GridFullHeight>
      </GridFormContainer>
    </GridFullHeight>
  );
});

export default connect(mapStateToProps)(MyWork);
